import axiosService from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';

export const centrifugeServices = {
  getNotificationConnect: async () => {
    return axiosService.get(getEndpointBase('notifications/connect'));
  },
};
